import { AppContext } from '../utils/app-context.js';
import { RESTUtils } from '../utils/rest-utils.js';
export class TrackClient {
    static getBaseUrl() {
        return AppContext.getTrackerUrl();
    }
    static async log(opts) {
        let session = AppContext.getFromContext('track-session-id');
        if (!session) {
            session = Math.random().toString(36).substring(2, 15);
            AppContext.addToContext('track-session-id', session);
        }
        try {
            await RESTUtils.postJson(`${this.getBaseUrl()}/rest/check`, {
                ...opts,
                session,
            }, { handleError: false });
        }
        catch (error) {
            // not doing anything here, just catching the error to avoid breaking the app
        }
    }
    static async getLogs() {
        try {
            return await RESTUtils.getJson(`${this.getBaseUrl()}/rest/check`);
        }
        catch (error) {
            console.log(error);
            return [];
        }
    }
}
